import services from "@/constants/env/services";

export const servicesMapping = Object.entries(services).reduce((acc, [k, v]) => ({ ...acc, [v]: k }), {});
